"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialPlannerRequest = void 0;
var FinancialPlannerRequest = /** @class */ (function () {
    function FinancialPlannerRequest() {
    }
    return FinancialPlannerRequest;
}());
exports.FinancialPlannerRequest = FinancialPlannerRequest;
;
//# sourceMappingURL=financialPlanner.request.js.map